import { render, staticRenderFns } from "./SendQuickReplyTemplate.vue?vue&type=template&id=244bb2cc&scoped=true&"
import script from "./SendQuickReplyTemplate.vue?vue&type=script&lang=js&"
export * from "./SendQuickReplyTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SendQuickReplyTemplate.vue?vue&type=style&index=0&id=244bb2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244bb2cc",
  null
  
)

export default component.exports